export default __webpack_public_path__ + "static/media/spitfire.e00f50b8.png";